import { render, staticRenderFns } from "./DevelopmentSet.vue?vue&type=template&id=497e5e40&scoped=true"
import script from "./DevelopmentSet.vue?vue&type=script&lang=js"
export * from "./DevelopmentSet.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentSet.vue?vue&type=style&index=0&id=497e5e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e5e40",
  null
  
)

export default component.exports